// Presentation only: never use this to rewrite storage keys, URLs, or record IDs.
// Keep casing, punctuation, hyphens, and typed trailing spaces intact.
export const displayLabel = (value) => {
  const text = typeof value === "string" ? value : value?.S;
  return typeof text === "string" ? text.replace(/_+/g, " ") : "";
};
